import {
    CONFIRMED_GET_USERS,
    CONFIRMED_DELETE_USER_ACTION
} from '../actions/user/UserTypes';
const initialState = {
    users: [],
    loading: false,
};

function UsersReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'SET_USERS_LOADING':
            return {
                ...state,
                loading: actions.payload,
            };
        case CONFIRMED_GET_USERS:
            return {
                ...state,
                users: actions.payload,
                loading: false,
            };
        case CONFIRMED_DELETE_USER_ACTION: {
            const users = [...state.users];
            const userIndex = users.findIndex(
                (user) => user._id === actions.payload,
            );
            users.splice(userIndex, 1);
            return {
                ...state,
                users,
            };
        }
        default:
            return state;
    }
}

export {UsersReducer};